import { render, staticRenderFns } from "./StudentPreview.vue?vue&type=template&id=617ca528&scoped=true&"
import script from "./StudentPreview.vue?vue&type=script&lang=js&"
export * from "./StudentPreview.vue?vue&type=script&lang=js&"
import style0 from "./StudentPreview.vue?vue&type=style&index=0&id=617ca528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617ca528",
  null
  
)

export default component.exports